import { SetObjectAccessorPropertyHelperBase } from './SetObjectAccessorPropertyHelperBase';
export class SetAccessorSymbolObjectPropertyHelper extends SetObjectAccessorPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getSymbolObject;
    }
}

//# sourceMappingURL=SetAccessorSymbolObjectPropertyHelper.js.map
